import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useRowEditor } from "../context/QuoteEditorContext"
import { useRowSelection } from "../context/TreeViewContext"
import RowMenu     from "./RowMenu"
import RowCheckbox from "./RowCheckbox"
import IconBadge   from "@react/shared/ui/IconBadge"
import DragHandle  from "@react/shared/ui/DragHandle"
import { TreeLead } from "@react/shared/ui/TreeGuides"
import { RichTextEditor, RichTextView, isBlank } from "./RichText"

const TEXT = "text-[12.5px] leading-[1.45] text-slate-600"

const DescriptionBlock = ({ node, sectionUid = null, depth = 0, trail = [], last = false }) => {
  const { dispatch } = useRowEditor()
  const selection = useRowSelection(node._uid)

  const value = node.description || ""
  const [editing, setEditing] = useState(!!node._focusDescription)

  useEffect(() => {
    if (node._focusDescription) {
      dispatch({ type: "UPDATE_NODE", payload: { nodeUid: node._uid, fields: { _focusDescription: false } } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChange = html =>
    dispatch({ type: "UPDATE_NODE", payload: { nodeUid: node._uid, field: "description", value: html } })

  return (
    <div
      data-uid       = {node._uid}
      onFocusCapture = {() => sectionUid && dispatch({ type: "SET_ACTIVE_SECTION", payload: { sectionUid } })}
      className      = "qb-grid qb-row-line items-center px-3 py-1 bg-white relative group hover:bg-slate-50"
    >
      <div className="qb-tree col-start-1 col-end-11 row-start-1 flex items-stretch self-stretch min-w-0">
        <div className="flex items-center gap-1 shrink-0">
          <RowCheckbox
            checked   = {selection.checked}
            onToggle  = {selection.onToggle}
            label     = {I18n.t("quotes.builder.selection.check_row")}
          />
          <DragHandle
            reveal    = "onHover"
            size      = "sm"
            icon      = "bars"
            className = "!opacity-0 group-hover:!opacity-100 shrink-0"
          />
        </div>

        <div className="flex items-stretch shrink-0 ml-1">
          <TreeLead depth={depth} trail={trail} last={last} />
          <span className="shrink-0 flex items-center">
            <IconBadge tone="slate" size="sm" title={I18n.t("quotes.builder.description.badge_title")}>
              <FontAwesomeIcon icon="align-left" />
            </IconBadge>
          </span>
        </div>

        <div className="qb-tree-label flex-1 min-w-0 flex items-center pl-5">
          <div className="w-full min-w-0 py-0.5">
            {editing ? (
              <RichTextEditor
                value       = {value}
                placeholder = {I18n.t("quotes.builder.description.editing_hint")}
                onChange    = {onChange}
                onDone      = {() => setEditing(false)}
                onCancel    = {() => setEditing(false)}
                className   = {TEXT}
              />
            ) : !isBlank(value) ? (
              <RichTextView
                value     = {value}
                onClick   = {() => setEditing(true)}
                title     = {I18n.t("quotes.builder.description.click_to_edit")}
                className = {`${TEXT} cursor-text`}
              />
            ) : (
              <span
                onClick   = {() => setEditing(true)}
                className = "block text-[12.5px] italic text-slate-400 cursor-text"
              >
                {I18n.t("quotes.builder.description.placeholder")}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-start-11 row-start-1 flex items-center justify-end">
        <RowMenu node={node} />
      </div>
    </div>
  )
}

export default DescriptionBlock
